import { Route, Routes, Outlet } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../../../_metronic/layout/core'
import React, { FC, Suspense } from 'react'
import { RewardsMenu } from './RewardsMenu'
import TopBarProgress from 'react-topbar-progress-indicator'
import { getCSSVariableValue } from '../../../../../_metronic/assets/ts/_utils'
import { WithChildren } from '../../../../../_metronic/helpers'
import { UserInformationWrapper } from '../../data-administration/data-admininstration-list/userInformation/userInformationList'
import { CouponsWrapper2 } from '../settting-modules/CouponsSupplyChain/Coupons'

// const usersBreadcrumbs: Array<PageLink> = [
//     {
//         title: 'Transactions',
//         path: '/apps/waste-source',
//         isSeparator: false,
//         isActive: false,
//     },
//     {
//         title: '',
//         path: '',
//         isSeparator: true,
//         isActive: false,
//     },
// ]


const usersBreadcrumbs: Array<PageLink> = [
    {
        title: 'Rewards',
        path: '/apps/rewards',
        isSeparator: false,
        isActive: false,
    },
]

const RewardsPage = () => {
    return (
        <Routes>
            <Route element={<Outlet />}>
                <Route index element={<RewardsMenu />} />
                <Route
                    path='coupons-1'
                    element={
                        <SuspensedView>
                            <PageTitle breadcrumbs={usersBreadcrumbs}>Coupons</PageTitle>
                            <CouponsWrapper2 />
                        </SuspensedView>
                    }
                />
            </Route>
        </Routes>
    )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
    const baseColor = getCSSVariableValue('--bs-primary')
    TopBarProgress.config({
        barColors: {
            '0': baseColor,
        },
        barThickness: 1,
        shadowBlur: 5,
    })
    return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export default RewardsPage
